"use client";

import React, { useEffect, useState } from "react";
import {
  Card,
  Table,
  Button,
  Spinner,
  Badge,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import Swal from "sweetalert2";

const StoreOrders = () => {
  const navigate = useNavigate();

  const [orders, setOrders] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const fetchOrders = async () => {
    try {
      const { data } = await api.get(
        "/orders/store"
      );

      setOrders(
        Array.isArray(data)
          ? data
          : data.items || []
      );
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "خطا",
        text:
          "دریافت سفارش‌ها انجام نشد.",
        confirmButtonText:
          "باشه",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const statusVariant = (
    status
  ) => {
    switch (
      String(status).toUpperCase()
    ) {
      case "CONFIRMED":
        return "success";

      case "PAID":
        return "success";

      case "PENDING":
        return "warning";

      case "CANCELLED":
      case "REJECTED":
        return "danger";

      default:
        return "secondary";
    }
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <Card className="border-0 rounded-3">
      <Card.Body className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="mb-0">
            سفارش‌های فروشگاه
          </h3>

          <Button
            variant="outline-primary"
            onClick={fetchOrders}
          >
            <span className="material-symbols-outlined align-middle">
              refresh
            </span>
          </Button>
        </div>

        <div className="table-responsive">
          <Table
            striped
            hover
            responsive
            className="align-middle"
          >
            <thead>
              <tr>
                <th>کد سفارش</th>
                <th>مبلغ</th>
                <th>وضعیت</th>
                <th>تاریخ</th>
                <th>عملیات</th>
              </tr>
            </thead>

            <tbody>
              {orders.length === 0 ? (
                <tr>
                  <td
                    colSpan={5}
                    className="text-center"
                  >
                    سفارشی وجود ندارد.
                  </td>
                </tr>
              ) : (
                orders.map((order) => {
                  const code =
                    order.code ||
                    order.orderCode;

                  return (
                    <tr key={code}>
                      <td>
                        <strong>
                          {code}
                        </strong>
                      </td>

                      <td>
                        {Number(
                          order.payableAmount ||
                            order.totalAmount ||
                            order.amount ||
                            0
                        ).toLocaleString(
                          "fa-IR"
                        )}{" "}
                        تومان
                      </td>

                      <td>
                        <Badge
                          bg={statusVariant(
                            order.status
                          )}
                        >
                          {order.status ||
                            "-"}
                        </Badge>
                      </td>

                      <td>
                        {order.createdAt
                          ? new Date(
                              order.createdAt
                            ).toLocaleDateString(
                              "fa-IR"
                            )
                          : "-"}
                      </td>

                      <td>
                        <Button
                          size="sm"
                          variant="primary"
                          onClick={() =>
                            navigate(
                              `/store/orders/${code}`
                            )
                          }
                        >
                          جزئیات
                        </Button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default StoreOrders;